
import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { SortableItem } from "./SortableItem";

interface OfferingWithOrder {
  id: string;
  title: string;
  description: string;
  price_cents: number;
  duration_minutes: number;
  is_active: boolean;
  display_order: number;
  game?: { id: string; name: string } | null;
  cover_image_url?: string | null;
}

interface SortableListProps {
  offerings: OfferingWithOrder[];
  moveItem: (index: number, direction: 'up' | 'down') => void;
}

export const SortableList: React.FC<SortableListProps> = ({
  offerings,
  moveItem
}) => {
  return (
    <Droppable droppableId="offerings">
      {(provided) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          className="space-y-4"
        >
          {offerings.map((offering, index) => (
            <SortableItem
              key={offering.id}
              offering={offering}
              index={index}
              moveItem={moveItem}
              isLastItem={index === offerings.length - 1}
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};
